import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import EmojiPicker from "emoji-picker-react";
import { sendLiveChatMessage } from "../../store/actions/tenantAction";
import AttachmentPopup from "./AttachmentPopup";
import { getFile } from "../../store/actions/globalAction";

export default function ChatInputBox({ searchParams, selectedContact }) {
    const [typedMessage, setTypedMessage] = useState("");
    const [isSendEnable, setIsSendEnable] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const [bodyTextCurrentIndex, setBodyTextCurrentIndex] = useState("");
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [showAttach, setShowAttach] = useState(false);
    const [previewfile, setPreviewfile] = useState(null);
    const [uploadFileData, setUploadFileData] = useState(null);
    const dropdownEmojiRef = useRef(null);
    let dispatch = useDispatch();
    const globalReducer = useSelector((state) => state.globalReducer);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownEmojiRef.current &&
                !dropdownEmojiRef.current.contains(event.target)
            ) {
                setShowEmojiPicker(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const onSendMessage = () => {
        if (!typedMessage.trim()) return;
        if (isSending) return;
        setIsSending(true);
        setIsSendEnable(false);
        setIsSendEnable(false);
        dispatch(
            sendLiveChatMessage(
                {
                    tenantId: globalReducer.loginInfo?.tenantId,
                    contact: selectedContact,
                    contactId: selectedContact?.id,
                    tenantWabaId: searchParams.get("tenantWabaId"),
                    messageType: "LIVE_CHAT",
                    source: "WEBLIVECHAT",
                    languageCode: "en-US",
                    type: "text",
                    isReceived: true,
                    message: { text: { body: typedMessage }, type: "text" },
                },
                (a) => {
                    setTypedMessage("");
                    setIsSending(false);
                },
                false
            )
        );
    };

    const onSendFileMessage = () => {
        setIsSending(true);
        setIsSendEnable(false);
        let messageData = { id: uploadFileData?.id, link: process.env.REACT_APP_PRODUCT_APIURL + "/storage/media/file?kay=" + uploadFileData?.url };
        if (uploadFileData?.type === "audio") {
            messageData = { id: uploadFileData?.id, link: process.env.REACT_APP_PRODUCT_APIURL + "/storage/media/file?kay=" + uploadFileData?.url };
        } else if (uploadFileData?.type === "document") {
            messageData = { id: uploadFileData?.id, caption: uploadFileData?.filename, filename: uploadFileData?.filename, link: process.env.REACT_APP_PRODUCT_APIURL + "/storage/media/file?kay=" + uploadFileData?.url };
        }
        dispatch(sendLiveChatMessage(
            {
                tenantId: globalReducer.loginInfo?.tenantId,
                contact: selectedContact,
                contactId: selectedContact?.id,
                tenantWabaId: searchParams.get("tenantWabaId"),
                messageType: "LIVE_CHAT",
                source: "WEBLIVECHAT",
                languageCode: "en-US",
                type: uploadFileData?.type,
                isReceived: true,
                message: { [uploadFileData?.type]: messageData, type: uploadFileData?.type, },
            },
            (a) => {
                setIsSending(false);
                setPreviewfile(null);
                setUploadFileData(null);
                setShowAttach(false);
            },
            false
        ));
    };

    const insertText = (index, text, newText) => {
        return `${text.slice(0, index)}${newText}${text.slice(index)}`;
    };

    const getMediaPreview = (file) => {
        getFile(file.url).then(sf => {
            switch (file?.type) {
                case "image":
                    setPreviewfile(<img
                        className={"object-cover rounded-lg"}
                        src={sf}
                    />);
                    break;
                case "video":
                    setPreviewfile(<video
                        className="object-fill rounded-md w-full mx-auto pb-5"
                        controls>
                        <source src={sf} type={file?.mediaType} />
                    </video>);
                    break;
                default:
                    setPreviewfile(<div className="mt-2 text-center w-full">
                        <p className="text-center text-[16px] font-medium leading-5">
                            {file?.filename?.split("/").pop()}
                        </p>
                    </div>);
                    break;
            }
        });
    };

    return (<div className="justify-bottom flex flex-col w-full h-auto">
        {previewfile ? <div>
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
                <div className="bg-gray-50 w-full max-w-md h-[85vh] rounded-xl flex flex-col overflow-hidden">
                    <div className="flex-1 flex items-center justify-center overflow-auto p-3">
                        {previewfile}
                    </div>
                    <div className="p-3 bg-white flex justify-between">
                        <button type="button" className="text-linear" onClick={() => { setPreviewfile(null); setUploadFileData(null); setShowAttach(false); }}>
                            Cancel
                        </button>
                        <button type="button" className="text-white px-4 py-2 rounded" onClick={() => onSendFileMessage()} style={{ backgroundColor: searchParams.get("primary") }}>
                            Send
                        </button>
                    </div>
                </div>
            </div>
        </div> :
            <div className="flex items-center gap-2 bg-white px-3 py-2">
                {showAttach && <AttachmentPopup selectedContact={selectedContact} wabaId={searchParams.get("tenantWabaId")} setUploadFileData={(fl) => { getMediaPreview(fl); setUploadFileData(fl); setShowAttach(false); }} onClose={() => setShowAttach(false)} />}
                <button className="text-gray-500" onClick={() => setShowEmojiPicker(!showEmojiPicker)}>😊</button>
                <div className="absolute z-99 bottom-14" ref={dropdownEmojiRef}>
                    <EmojiPicker
                        open={showEmojiPicker}
                        autoFocusSearch
                        onEmojiClick={(em) => {
                            setTypedMessage(
                                insertText(
                                    bodyTextCurrentIndex ?? 0,
                                    typedMessage ?? "",
                                    em.emoji
                                )
                            );
                            setBodyTextCurrentIndex(
                                (bodyTextCurrentIndex ?? 0) + em.emoji?.length
                            );
                        }}
                    />
                </div>

                <input
                    className="flex-1 border border-gray-200 rounded-full px-4 py-2 text-sm outline-none"
                    placeholder="Type a message"
                    value={typedMessage}
                    onChange={(e) => {
                        setTypedMessage(e.target.value);
                        setIsSendEnable(e.target.value ? true : false);
                    }}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' && !event.shiftKey) {
                            event.preventDefault(); // Prevents new line from being added
                            onSendMessage();
                        }
                    }}
                />

                <button type="button" className="text-gray-900 bg-gray-200 p-2 rounded-2xl" onClick={() => setShowAttach(true)}>📎</button>

                <button onClick={onSendMessage} disabled={isSending}
                    className="text-white w-9 h-9 rounded-full flex items-center justify-center" style={{ backgroundColor: searchParams.get("primary") }}>
                    ➤
                </button>
            </div>}
    </div>
    );
}
